
export const hasClass = (el: HTMLElement, cls: string) => {
  if (el.className) {
    return el.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
  }
  return false;
};

export const addClass = (el: HTMLElement, cls: string) => {
  if (!hasClass(el, cls)) {
    el.className += ' ' + cls;
  }
};
